import { 
    collection, 
    doc, 
    getDocs, 
    getDoc, 
    addDoc, 
    updateDoc, 
    deleteDoc,
    query,
    orderBy,
    serverTimestamp 
} from 'firebase/firestore';
import { db } from '../utils/firebase/config';

// ========== CATEGORIES ==========
export const getCategories = async () => {
    try {
        const q = query(collection(db, 'Categories'), orderBy('position'));
        const querySnapshot = await getDocs(q);
        const categories = [];
        querySnapshot.forEach((doc) => {
            categories.push({ id: doc.id, ...doc.data() });
        });
        return { success: true, data: categories };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const createCategory = async (categoryData) => {
    try {
        const docRef = await addDoc(collection(db, 'Categories'), {
            ...categoryData,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
        });
        return { success: true, id: docRef.id };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const updateCategory = async (id, categoryData) => {
    try {
        const categoryRef = doc(db, 'Categories', id);
        await updateDoc(categoryRef, {
            ...categoryData,
            updatedAt: serverTimestamp()
        });
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const deleteCategory = async (id) => {
    try {
        await deleteDoc(doc(db, 'Categories', id));
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

// ========== SUBCATEGORIES ==========
export const getSubCategories = async (categoryId = null) => {
    try {
        console.log('🔍 Consultando SubCategories...', categoryId ? `para categoría ${categoryId}` : 'todas');
        const subCategories = [];
        
        if (categoryId) {
            // Si se proporciona categoryId, obtenemos subcategorías de esa categoría específica
            const subCategoriesRef = collection(db, 'Categories', categoryId, 'SubCategories');
            const querySnapshot = await getDocs(subCategoriesRef);
            console.log(`📊 Subcategorías encontradas en ${categoryId}:`, querySnapshot.size);
            
            querySnapshot.forEach((doc) => {
                subCategories.push({ 
                    id: doc.id, 
                    categoryId: categoryId,
                    ...doc.data() 
                });
            });
        } else {
            // Si no hay categoryId, obtenemos subcategorías de todas las categorías
            const categoriesSnapshot = await getDocs(collection(db, 'Categories'));
            console.log('📊 Categorías encontradas:', categoriesSnapshot.size);
            
            for (const categoryDoc of categoriesSnapshot.docs) {
                const subCategoriesRef = collection(db, 'Categories', categoryDoc.id, 'SubCategories');
                const subCategoriesSnapshot = await getDocs(subCategoriesRef);
                console.log(`📊 Subcategorías en ${categoryDoc.id}:`, subCategoriesSnapshot.size);
                
                subCategoriesSnapshot.forEach((doc) => {
                    subCategories.push({ 
                        id: doc.id, 
                        categoryId: categoryDoc.id,
                        ...doc.data() 
                    });
                });
            }
        }
        
        console.log('✅ Total SubCategories cargadas:', subCategories.length);
        console.log('📄 SubCategories:', subCategories);
        return { success: true, data: subCategories };
    } catch (error) {
        console.error('❌ Error en getSubCategories:', error);
        return { success: false, error: error.message };
    }
};

export const createSubCategory = async (subCategoryData) => {
    try {
        const { categoryId, ...restData } = subCategoryData;
        if (!categoryId) {
            throw new Error('categoryId es requerido');
        }
        
        const subCategoriesRef = collection(db, 'Categories', categoryId, 'SubCategories');
        const docRef = await addDoc(subCategoriesRef, {
            ...restData,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
        });
        return { success: true, id: docRef.id };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const updateSubCategory = async (id, subCategoryData) => {
    try {
        const { categoryId, ...restData } = subCategoryData;
        if (!categoryId) {
            throw new Error('categoryId es requerido');
        }
        
        const subCategoryRef = doc(db, 'Categories', categoryId, 'SubCategories', id);
        await updateDoc(subCategoryRef, {
            ...restData,
            updatedAt: serverTimestamp()
        });
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const deleteSubCategory = async (id, categoryId) => {
    try {
        if (!categoryId) {
            throw new Error('categoryId es requerido');
        }
        
        await deleteDoc(doc(db, 'Categories', categoryId, 'SubCategories', id));
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

// ========== PRODUCTS ==========
export const getProducts = async (subCategoryId = null) => {
    try {
        let q = query(collection(db, 'Products'), orderBy('position'));
        
        const querySnapshot = await getDocs(q);
        const products = [];
        querySnapshot.forEach((doc) => {
            const data = { id: doc.id, ...doc.data() };
            if (!subCategoryId || data.subCategoryId === subCategoryId) {
                products.push(data);
            }
        });
        return { success: true, data: products };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const createProduct = async (productData) => {
    try {
        const docRef = await addDoc(collection(db, 'Products'), {
            ...productData,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
        });
        return { success: true, id: docRef.id };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const updateProduct = async (id, productData) => {
    try {
        const productRef = doc(db, 'Products', id);
        await updateDoc(productRef, {
            ...productData,
            updatedAt: serverTimestamp()
        });
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const deleteProduct = async (id) => {
    try {
        await deleteDoc(doc(db, 'Products', id));
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};
